import { QuestionRenderer } from './QuestionRenderer';
import type { QuestionDef, AnswerValue } from '../types';

interface StepRendererProps {
  questions: QuestionDef[];
  answers: Record<string, AnswerValue>;
  setAnswer: (questionId: string, answer: AnswerValue) => void;
}

/**
 * ステップ内の質問群をレンダリング
 */
export function StepRenderer({ questions, answers, setAnswer }: StepRendererProps) {
  return (
    <div className="space-y-6">
      {questions.map((question, idx) => (
        <QuestionRenderer
          key={question.id}
          question={question}
          answer={answers[question.id]}
          setAnswer={setAnswer}
          isFirst={idx === 0}
        />
      ))}
    </div>
  );
}
